module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_8023.458406dc.png";